export default "__VITE_ASSET__CIgYKPR3__"